import { isReportCompleted } from "@utils/reportStatus";
import React from "react";

import { Button } from "@fronterahealth/frontera-ui-components";

import { useCreateReportSectionsMutation } from "@api/graphql/types-and-hooks";
import { NoDataCard } from "@components/NoDataCard/NoDataCard";
import { ReportSection } from "@components/ReportField/ReportSection";
import {
  FilterSectionSubRoute,
  useGetFilteredPageSectionsByLocation,
} from "@pages/EvaluationDetails/Components/helper";
import { FooterButtonRow } from "@pages/EvaluationDetails/EvaluationDetailsSubPages/FooterButtonRow";
import { StickyNav } from "@pages/EvaluationDetails/EvaluationDetailsSubPages/StickyNav/StickyNav";
import { useReport } from "@providers/ReportProvider";

const pageLocation: FilterSectionSubRoute = "appendix";

export const EvaluationAppendix: React.FC = () => {
  const filteredSections = useGetFilteredPageSectionsByLocation(pageLocation);

  const { report, reportQuery } = useReport();
  const reportIsCompleted = isReportCompleted(report);

  const createSection = useCreateReportSectionsMutation({});
  const { isPending } = createSection;
  const onAddSection = async () => {
    await createSection
      .mutateAsync({
        reportId: report.id,
        runWorkflow: false,
        sections: [{ title: "Enter Section Title", pageLocation: pageLocation, rankOrder: 1 }],
      })
      .then((data) => {
        if (data.createReportSections?.status) {
          reportQuery.refetch();
        }
      });
  };

  return (
    <div className="flex w-full flex-col pb-6">
      <div className="grid grid-cols-4 gap-x-1">
        <div className={`col-span-3 flex w-full flex-col gap-y-4`}>
          {filteredSections.length === 0 && (
            <NoDataCard
              title="You have no appendix section added"
              description={<span>Appendix section that you add will end up here.</span>}
            >
              <Button
                text={isPending ? "Adding..." : "Add Appendix Section"}
                appearance="primary"
                buttonAction="action"
                disabled={isPending}
                className="mt-2"
                onClick={() => onAddSection()}
              />
            </NoDataCard>
          )}
          {filteredSections.map((section) => (
            <ReportSection key={section.id} section={section} disabled={reportIsCompleted} />
          ))}
        </div>

        <div className="flex w-full flex-col pl-8">
          <StickyNav state={filteredSections} />
        </div>
      </div>
      <FooterButtonRow primaryButtonTitle="Next" />
    </div>
  );
};
